import React, { useState } from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/client'
import { SpinnerButton } from '@/components/common/button'
import { LlmChatQueueQuery } from './__gen'

type Chat = NonNullable<LlmChatQueueQuery['llmChatAdmin_List']>['objects'][number]

type Props = {
	chat: Chat
}

const SET_RESPONSE_HTML_MUTATION = gql`
	mutation setResponseHtml($html: String!, $createdByLlmChat: ID!, $form: ID!, $record: ID!) {
		llmResponseHtml_Update(input: {html: $html, createdByLlmChat: $createdByLlmChat, form: $form, record: $record }) {
			object {
				id
			}
		}
	}
`

export const SetResponseHtmlButton = ({ chat }: Props) => {
	const html = `<div><h3>LlmHtmlResponse: ${Math.random()}</h3></div>`
	const [mutate, { loading, error }] = useMutation(SET_RESPONSE_HTML_MUTATION, { variables: {html, createdByLlmChat: chat.id, form: chat.formId, record: chat.recordId } })

	if (error) {
		return <p>Error: {error.message}</p>
	}


	return (
		<SpinnerButton
			disabled={loading}
			loading={loading}
			onClick={() => mutate()}
		>
			Set
		</SpinnerButton>
	)
}
